import React, { useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import ChartStyle from "styles/ChartStyle";
import { chartLineWidth } from "styles/variables";
import ChartConfig from "utils/ChartConfig";
import * as H from "helper";
import * as V from 'styles/variables';

const useStyles = makeStyles((theme) => ({
  chartContainer: {
    marginTop: 16,
    marginLeft: 16,
    width: "100%",
    display: "block",
  },
}));

const LineChartPicTreeMission = ({
  title,
  legend,
  lblSaveImage,
  xAisData,
  seriesData,
  chartType,
}) => {
  const classes = useStyles();
  const [seriesType, setSeriesType] = useState(chartType);
  const [color, setColorArray] = useState([V.genericColorPallette[0], V.genericColorPallette[1], V.genericColorPallette[2],
    V.genericColorPallette[3], V.genericColorPallette[4], V.genericColorPallette[5], V.genericColorPallette[6]]);
  const [stackState, setStackState] = useState("");

  useEffect(() => {
    echarts.registerTheme("BarChartTheme", ChartStyle);
  }, []);

  const magicTypeChanged = (param) => {
    if (param.currentType === "stack") {
      setStackState("__ec_magicType_stack__");
    } else {
      setSeriesType(param.currentType);
    }
  };

  const onEvents = {
    magictypechanged: magicTypeChanged,
  };

  return (
    <div className={classes.chartContainer}>
      <ReactEcharts
        option={{
          title: {
            text: title,
            textStyle: {
              fontWeight: "normal",
              fontSize: 14,
            },
            padding: [2, 0, 0, 30],
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "none",
            },
            order: "seriesAsc",
          },
          grid: {
            left: 64,
            top: "25%",
            right: 48,
            bottom: 42,
          },
          legend: {
            show: true,
            data: legend,
            padding: [
              5, // up
              10, // right
              5, // down
              10, // left
            ],
          },
          toolbox: {
            show: true,
            feature: {
              magicType: {
                show: false,
                type: ["bar", "line"],
                title: {
                  line: "Line",
                  bar: "Bar",
                  stack: "Stack",
                  tiled: "Side by Side",
                },
                icon: {
                  line: "image://../../static/images/font-icon/line-chart.svg",
                  bar: "image://../../static/images/font-icon/bar-chart.svg",
                },
              },
              saveAsImage: {
                show: false,
                title: "Save",
                name: lblSaveImage,
                icon: "image://../../static/images/font-icon/save-chart.svg",
              },
            },
          },
          xAxis: {
            type: "category",
            data: xAisData,
          },
          yAxis: [
            {
              type: "value",
              name: "件",
              minInterval: 1,
            },
          ],
          series: seriesData,
          color: color,
        }}
        theme="BarChartTheme"
        notMerge={true}
        lazyUpdate={true}
        onEvents={onEvents}
        style={{ height: "350px", width: "98%" }}
      />
    </div>
  );
};

LineChartPicTreeMission.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(LineChartPicTreeMission));
